<template>
  <div class="product-run-continue-page-content">
    <div class="green-font mb-15">
      {{ $t('text.run') }}:
      {{
        userLang.indexOf('en') > -1
          ? moment(charData.startedTime)
              .tz(utcOffset)
              .format('DD MMM YY')
          : moment(charData.startedTime)
              .tz(utcOffset)
              .format('DD/MM/YY')
      }}
      {{ $t('text.started') }}:
      {{
        moment(charData.startedTime)
          .tz(utcOffset)
          .format('h:mm a')
      }}
    </div>
    <div class="info-line">
      <div class="inline-block info-wrapper">
        <span class="mr-5 label">{{ $t('text.tester') }} :</span>
        <span class="mr-20">{{ charData.testerName }}</span>
        <br class="show-mobile" />
        <span class="mr-5 label">{{ $t('text.product') }} :</span>
        <span class="mr-20">{{ charData.productName }}</span>
        <br class="show-mobile" />
        <span class="mr-5 label">{{ $t('text.pod') }} :</span>
        <span class="mr-20">{{ charData.pod }}</span>
        <br class="show-mobile" />
        <span class="mr-5 label">{{ $t('text.position') }} :</span>
        <span class="mr-20">{{ charData.position }}</span>
        <br class="show-mobile" />
        <span class="mr-5 label">{{ $t('text.weight') }}(Kg) :</span>
        <span>{{ charData.comments }}</span>
      </div>
      <br class="show-mobile" />
      <el-button
        class="save-btn mini-btn finish-btn"
        @click="finish()"
        :loading="saveLoading"
        >{{ $t('text.finish').toUpperCase() }}</el-button
      >
    </div>
    <div class="entries-secion">
      <div class="dark-font bold-font">{{ $t('text.entries') }}</div>
      <el-row :gutter="30">
        <el-col :xs="24" :md="12" :class="screenWidth < 1024 ? 'mb-30' : ''">
          <el-form
            :inline="true"
            :model="voidForm"
            :rules="voidRules"
            ref="voidForm"
          >
            <el-form-item :label="$t('text.void') + ' (ml)'" prop="volume">
              <el-input-number
                v-model="voidForm.volume"
                size="mini"
                controls-position="right"
                :min="0"
                class="w-120"
              ></el-input-number>
            </el-form-item>
            <el-form-item class="right-float mr-0">
              <b-button
                size="sm"
                variant="outline-primary"
                class="min-w-80"
                @click="addVoid()"
                >{{ $t('text.add_entry') }}</b-button
              >
            </el-form-item>
          </el-form>
          <el-table border :data="volData" size="mini" height="145">
            <el-table-column :label="$t('text.time')" prop="localtime">
              <template slot-scope="scope">
                <span>{{
                  moment
                    .utc(scope.row.time)
                    .tz(utcOffset)
                    .format('h:mm a')
                }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('text.void') + ' (ml)'" prop="volume">
            </el-table-column>
            <el-table-column :label="$t('text.action') | firstLetterCapitalize">
              <template slot-scope="scope">
                <span
                  class="underline blue-font pointer"
                  @click="editVoid(scope.row, scope.$index)"
                  >{{ $t('text.edit') }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :xs="24" :md="12">
          <el-form :inline="true" :model="commentForm" ref="commentForm">
            <el-form-item :label="$t('text.comment')" prop="pour">
              <el-input
                v-model="commentForm.pour"
                type="textarea"
                size="mini"
                class="w-120"
              ></el-input>
            </el-form-item>
            <el-form-item class="right-float mr-0">
              <b-button
                size="sm"
                variant="outline-primary"
                class="min-w-80"
                @click="addComment()"
                >{{ $t('text.add_entry') }}</b-button
              >
            </el-form-item>
          </el-form>
          <el-table border :data="commentData" size="mini" height="145">
            <el-table-column :label="$t('text.time')" prop="localtime">
              <template slot-scope="scope">
                <span>{{
                  moment
                    .utc(scope.row.time)
                    .tz(utcOffset)
                    .format('h:mm a')
                }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('text.comment')" prop="pour">
            </el-table-column>
            <el-table-column :label="$t('text.action') | firstLetterCapitalize">
              <template slot-scope="scope">
                <span
                  class="underline blue-font pointer"
                  @click="editComment(scope.row, scope.$index)"
                  >{{ $t('text.edit') }}</span
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <div class="mt-30">
      <div class="dark-font bold-font">{{ $t('text.pod_data') }}</div>
      <div
        id="echarts"
        :style="{
          width: '100%',
          height: '400px'
        }"
      ></div>
    </div>
    <EditVoid ref="editVoid" />
    <EditComment ref="editComment" />

    <el-tooltip placement="top">
      <div slot="content">
        {{
          connectionStatus === 0
            ? 'Connecting to Smartz® service...'
            : connectionStatus === 1
            ? 'Successfully connected to Smartz® service.'
            : 'Failed to connect to Smartz® service.'
        }}
      </div>
      <div
        class="connection-status"
        :class="
          connectionStatus === 2
            ? 'red-bg'
            : connectionStatus === 1
            ? 'green-bg'
            : ''
        "
      >
        {{
          connectionStatus === 0
            ? 'Connecting...'
            : connectionStatus === 1
            ? 'Connected'
            : 'Disconnected'
        }}
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import CommonApiService from '@/services/CommonApiService.js'
import EditVoid from '@/components/products/characterisation/EditVoid'
import EditComment from '@/components/products/characterisation/EditComment'
import Vue from 'vue'
export default {
  data() {
    return {
      moment,
      userLang: navigator.language || navigator.userLanguage,
      screenWidth: window.innerWidth,
      charData: {},
      voidForm: {
        volume: ''
      },
      voidRules: {
        volume: [
          {
            required: true,
            message: this.$t('text.void_required'),
            trigger: 'blur'
          }
        ]
      },
      commentForm: {
        pour: ''
      },
      volData: [],
      commentData: [],
      chart: '',
      chartTimer: '',
      saveLoading: false,
      isContinue: false,
      isFinished: false,
      source: [['time', 'sensor1', 'sensor2']],
      option: {},
      connectionStatus: 2 // 0: Connecting, 1: Connected, 2: Disconnected
    }
  },
  props: {
    utcOffset: {
      type: String,
      required: true
    }
  },
  components: {
    EditVoid,
    EditComment
  },
  mounted: function() {
    this.initSignalR()
    window.addEventListener('resize', this.getScreenWidth)
    window.addEventListener('beforeunload', this.handleDestory)
    this.$hub.$on('pod-data-received', this.onPodDataReceived)
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.initChart()
    },
    'charData.pod': function() {
      this.source = [['time', 'sensor1', 'sensor2']]
      this.addNewToGroup()
    },
    utcOffset() {
      if (this.chart) {
        this.chart.setOption(this.option)
      }
    }
  },
  methods: {
    initSignalR() {
      this.connectionStatus = 0
      Vue.prototype
        .startSignalR()
        .then(() => {
          this.connectionStatus = 1
        })
        .catch(() => {
          this.connectionStatus = 2
        })
    },
    addNewToGroup() {
      this.connectionStatus = 0
      Vue.prototype
        .addToGroup(this.charData.pod)
        .then(() => {
          this.connectionStatus = 1
        })
        .catch(() => {
          this.connectionStatus = 2
        })
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    },
    onPodDataReceived(data) {
      if (data.podMac === this.charData.pod) {
        // 1. sensor values & accelerometer values (ax, ay, az) are only on even tickcounter
        // 2. Only show sensor values for the incoming packet which has contractorId 1
        if (data.tickCounter % 2 === 0 && data.contractorId === 1) {
          let time = moment(data.timeStamp)
            .utc()
            .format('YYYY-MM-DD HH:mm:ss')
          let calculatedData = [time, data.sensor1Value, data.sensor2Value]
          this.source.push(calculatedData)
          this.source.forEach((item, index) => {
            //Remove more than 15 minutes data
            if (index > 0) {
              let timeDiff = moment(time).diff(moment(item[0]), 'minutes')
              if (timeDiff >= 15) {
                this.source.splice(index, 1)
              }
            }
          })
          this.option.dataset.source = this.source
          this.chart.setOption(this.option)
        }
      }
    },
    addVoid() {
      this.$confirm(
        this.$t('text.whether_continue'),
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.add'),
          cancelButtonText: this.$t('text.cancel'),
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }
      ).then(() => {
        this.$refs.voidForm.validate(valid => {
          if (valid) {
            this.volData.push({
              localtime: new Date().toLocaleString(),
              time: new Date().toUTCString(),
              volume: this.voidForm.volume
            })
            this.$refs.voidForm.resetFields()
          }
        })
      })
    },
    editVoid(row, index) {
      this.$refs.editVoid.openDialog()
      //Displays the time after applying the UTC Offset
      this.$refs.editVoid.form = {
        time: moment
          .utc(row.time)
          .tz(this.utcOffset)
          .format('YYYY-MM-DD HH:mm:ss'),
        volume: row.volume
      }
      this.$refs.editVoid.index = JSON.parse(JSON.stringify(index))
    },
    addComment() {
      this.$confirm(
        this.$t('text.whether_continue'),
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: this.$t('text.add'),
          cancelButtonText: this.$t('text.cancel'),
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }
      ).then(() => {
        this.commentData.push({
          localtime: new Date().toLocaleString(),
          time: new Date().toUTCString(),
          pour: this.commentForm.pour
        })
        this.$refs.commentForm.resetFields()
      })
    },
    editComment(row, index) {
      this.$refs.editComment.openDialog()
      //displays the time after applying the UTC Offset
      this.$refs.editComment.form = {
        time: moment
          .utc(row.time)
          .tz(this.utcOffset)
          .format('YYYY-MM-DD HH:mm:ss'),
        pour: row.pour
      }
      this.$refs.editComment.index = JSON.parse(JSON.stringify(index))
    },
    getParams() {
      return {
        charData: {
          ...this.charData,
          // fix new Date() function not working in safari
          startedTime: new Date(
            this.charData.startedTime.replace(/-/g, '/')
          ).toUTCString(),
          endTime: new Date().toUTCString()
        },
        volData: this.volData,
        commentData: this.commentData
      }
    },
    finish() {
      this.$confirm(
        'You will finish this test, please confirm whether to continue',
        this.$t('text.are_you_sure'),
        {
          confirmButtonText: 'OK',
          cancelButtonText: this.$t('text.cancel'),
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }
      ).then(() => {
        this.handleFinish()
      })
    },
    handleFinish() {
      this.saveLoading = true
      CommonApiService.SaveCharacterization(this.getParams())
        .then(() => {
          this.saveLoading = false
          this.isFinished = true
          clearInterval(this.chartTimer)
          if (this.isContinue) {
            localStorage.removeItem('incomplete_run')
          }
          this.$parent.$refs.runInit.incompleteRunRecord = JSON.parse(
            localStorage.getItem('incomplete_run')
          )
          this.volData = []
          this.commentData = []
          this.charData = {}
          this.$parent.haveInit = false
        })
        .catch(() => {
          this.saveLoading = false
        })
    },
    initChart() {
      let vm = this
      var dom = document.getElementById('echarts')
      this.chart = this.echarts.init(dom)
      this.option = {
        grid: {
          left: 10,
          right: 30,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            let tooltipStr = `<div>${moment(params[0].axisValue)
              .add(moment.tz(vm.utcOffset).utcOffset() / 60, 'hours')
              .format('DD/MM/YY HH:mm:ss')}</div>`
            params.forEach(item => {
              if (tooltipStr.indexOf(item.color) < 0) {
                tooltipStr =
                  tooltipStr +
                  `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                    item.color
                  }"></div>${item.seriesName} : ${
                    item.value[item.seriesIndex + 1]
                  }</div>`
              }
            })
            return tooltipStr
          }
        },
        color: ['#008ffb', '#00e396'],
        legend: {
          x: 'center',
          y: 'bottom',
          data: [this.$t('text.sensor') + '1', this.$t('text.sensor') + '2']
        },
        dataset: {
          dimensions: ['time', 'sensor1', 'sensor2'],
          source: this.source
        },
        xAxis: [
          {
            type: 'time',
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function(value) {
                let time = value
                  ? moment(value).add(
                      moment.tz(vm.utcOffset).utcOffset() / 60,
                      'hours'
                    )
                  : ''
                return time.format('HH:mm:ss') + '\n' + time.format('DD/MM/YY')
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            nameGap: 40,
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('text.sensor') + '1',
            type: 'scatter',
            encode: {
              x: 'time',
              y: 'sensor1'
            }
          },
          {
            name: this.$t('text.sensor') + '2',
            type: 'scatter',
            encode: {
              x: 'time',
              y: 'sensor2'
            }
          }
        ]
      }
      this.chart.setOption(this.option)
      window.addEventListener('resize', function() {
        vm.chart.resize()
      })
    },
    handleDestory() {
      clearInterval(this.chartTimer)
      if (this.charData.pod && !this.isFinished) {
        localStorage.setItem('incomplete_run', JSON.stringify(this.getParams()))
        this.isFinished = true
        this.charData = {}
      }
    }
  },
  beforeDestroy() {
    this.handleDestory()
  },
  destroyed() {
    Vue.prototype.stopSignalR()
  }
}
</script>

<style lang="scss" scoped>
.connection-status {
  padding: 5px 10px;
  font-weight: bold;
  font-size: 14px;
  position: fixed;
  right: 30px;
  top: 130px;
  background-color: #bbb;
  color: white;
  border-radius: 5px;
  &.red-bg {
    background-color: #ff4d4d;
  }
  &.green-bg {
    background-color: #4caf50;
  }
}
</style>
